import React from "react";
import { Calculator, Briefcase, Home as HomeIcon, Store, ArrowRight, Clock } from "lucide-react";
import { useModals } from "@/lib/modal-context";

const ITEMS = [
    { type: "office", title: "Office Fit-Out", badge: "Most popular", desc: "Get an approximate estimate for office fit-out, renovation, workstations, partitions and branding.", icon: <Briefcase className="h-7 w-7 text-[#5d6d00]" /> },
    { type: "home", title: "Home Interiors", badge: "Popular", desc: "Get an approximate estimate for apartment, villa or room interiors.", icon: <HomeIcon className="h-7 w-7 text-[#5d6d00]" /> },
    { type: "retail", title: "Retail / Restaurant", badge: "Fast to estimate", desc: "Get an approximate estimate for shop, showroom, café or restaurant design and branding.", icon: <Store className="h-7 w-7 text-[#5d6d00]" /> },
];

function Card({ item, onClick }) {
    return (
        <div className="rounded-3xl bg-white border border-black/10 p-7 card-lift fade-up">
            <div className="flex items-center justify-between">
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#F2FFB0]">{item.icon}</div>
                <span className="rounded-full bg-[#FFFDE8] border border-[#CCFF00]/40 px-3 py-1 text-[11px] font-bold text-[#5d6d00]">{item.badge}</span>
            </div>
            <h3 className="mt-6 font-display text-2xl font-bold">{item.title}</h3>
            <p className="mt-2 text-sm text-black/60 max-w-[18rem] leading-snug">{item.desc}</p>
            <div className="mt-5 flex items-center justify-between">
                <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-black/60"><Clock className="h-3.5 w-3.5" /> Takes &lt; 30 sec</span>
                <button onClick={() => onClick(item.type)} data-testid={`estimate-main-${item.type}-btn`} className="btn-pill pr-1.5 text-white" style={{ background: "#5d6d00" }}>
                    <span className="px-1 text-xs font-bold tracking-wider">GET ESTIMATE</span>
                    <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#CCFF00] text-black"><ArrowRight className="h-4 w-4" /></span>
                </button>
            </div>
        </div>
    );
}

export default function CostEstimatorMain() {
    const { openConnect } = useModals();

    const handleClick = (type) => {
        openConnect({ source: `cost_estimator_${type}`, spaceType: type });
    };

    return (
        <section id="contact" className="bg-[#FAFAF5] py-16 sm:py-20">
            <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-8">
                <div className="text-center fade-up">
                    <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-white border border-black/10">
                        <Calculator className="h-6 w-6 text-[#5d6d00]" />
                    </div>
                    <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-[52px] font-extrabold tracking-[-0.03em]">
                        Get an estimate for your <span className="text-[#7e9a00]">Dubai</span> space
                    </h2>
                    <p className="mt-3 text-sm text-black/60 max-w-2xl mx-auto">
                        Get an approximate cost direction based on your space type, size and requirements.
                    </p>
                </div>

                <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
                    {ITEMS.map((it) => (<Card key={it.type} item={it} onClick={handleClick} />))}
                </div>
            </div>
        </section>
    );
}
